import React from 'react';
export const WhyMedicineFails = () => {
  const rows = [{
    give: 'The pill, to regulate your cycle',
    need: 'Understanding why your cycle shifted in the first place'
  }, {
    give: 'Antidepressants, for mood',
    need: 'Supporting the liver, gut, and nervous system — where mood quietly begins'
  }, {
    give: 'Sleep aids, for restless nights',
    need: 'Restoring the natural rhythm that regulates rest'
  }, {
    give: "'It's just stress' — try slowing down",
    need: 'An integrated approach that treats the body as one connected system'
  }];
  return <section className="w-full bg-white py-8 md:py-12 px-4 md:px-6" data-id="element-280">
      <div className="max-w-[780px] mx-auto" data-id="element-281">
        <h2 className="font-playfair text-[28px] md:text-[38px] text-primary text-center mb-6" data-id="element-282">
          Why Nothing You've Tried Has Quite Worked
        </h2>

        <p className="font-lato text-[16px] md:text-[17px] text-secondary text-center max-w-[620px] mx-auto mb-8 leading-[1.7]" data-id="element-283">
          Many women never receive the full picture. Symptoms are often treated
          separately, one at a time — instead of as connected patterns inside a
          single, intelligent system.
        </p>

        <div className="rounded-[16px] border border-accent overflow-hidden" data-id="element-284">
          <div className="grid grid-cols-2" data-id="element-285">
            <div className="bg-errorBg text-error font-lato font-bold text-[16px] text-center p-4" data-id="element-286">
              Common Approaches
            </div>
            <div className="bg-[#F0EBF8] text-primary font-lato font-bold text-[16px] text-center p-4" data-id="element-287">
              What Your Body Actually Needs
            </div>
          </div>

          <div className="flex flex-col" data-id="element-288">
            {rows.map((row, index) => <div key={index} className={`grid grid-cols-2 border-t border-accent ${index % 2 === 0 ? 'bg-white' : 'bg-light'}`} data-id="element-289">
                <div className="font-lato text-[15px] text-body p-4 md:px-5 border-r border-accent flex items-center" data-id="element-290">
                  {row.give}
                </div>
                <div className="font-lato text-[15px] text-body p-4 md:px-5 flex items-center" data-id="element-291">
                  {row.need}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};